module.exports = __webpack_public_path__ + "img/avatar5.7b473757.png";